<template>
<v-layout row wrap >
  <v-flex
    v-for='col in cols' xs12 sm4 :key='col.value' :class="classWidth" >
    <v-toolbar dense flat dark  >
      <v-btn @click='toggleCol(col)'
        icon class='visible-xs-only' >
        <v-icon v-if='visible[col.value]' small >expand_less</v-icon>
        <v-icon v-else small >expand_more</v-icon>
      </v-btn>
      <v-badge right color="cyan" >
        <span slot="badge" >{{ getItems(col.value).length }} </span>
          <h3 class='subheading' >{{col.text}}</h3>
      </v-badge>
      <v-spacer></v-spacer>
      <v-btn v-if='withSearch' @click='showSearch = !showSearch' icon >
        <v-icon>search</v-icon>
      </v-btn>
      <span
        v-if='col.summary(getItems(col.value))'
        class='mr-2' >{{ col.summary(getItems(col.value)) }}</span>
      <!-- <v-subheader class='subheading' >{{col.text}}</v-subheader> -->
      <v-text-field
        v-if='showSearch'
        slot='extension'
        transition="slide-y-transition" >
      </v-text-field>
    </v-toolbar>
    <div v-if='visible[col.value]' >
    <slot name='list' :items="getItems(col.value)" :col='col' >
      <v-list dense >
        <v-list-tile v-for='item in getItems(col.value)' :key='item.id' >
          <v-list-tile-content>
            <v-list-tile-title>{{item.title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </slot>
    </div>
    <v-divider></v-divider>
  </v-flex>
</v-layout>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Kanban',
  props: {
    cols: { type: Array, default: () => { return [] } },
    data: { type: Array, default: () => { return {} } },
    withSearch: { type: Boolean, default: false }
  },
  data () {
    return {
      visible: {},
      showSearch: false
    }
  },
  mounted () {
    this.cols.forEach(col => {
      Vue.set(this.visible, col.value, true)
    })
  },
  methods: {
    getItems (lookup) {
      return this.$store.getters.getInvoicesByStatus(lookup)
    },
    toggleCol (col) {
      Vue.set(this.visible, col.value, !this.visible[col.value])
    }
  },
  computed: {
    classWidth () {
      let classes = ['xs' + (12 / this.cols.length)]
      if (this.$vuetify.breakpoint.xs) {
        classes.push('pa-0')
      }
      return classes
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Kanban.vue?06d2f58d